import React from 'react';
import PropTypes from 'prop-types';

import { crudConfig, uiConfig } from '../../conf/criteriaResources';

// // API Hooks
import { useCriteriaResources } from '../api/hooks/useCriteriaResources';

// UI Components
import { Button } from '../../../components/Button';
import Table from '../../../components/Table';
import AddEdit from './components/addEdit';
import { DeleteResource } from './components/deleteResource';

import { translateUIConfigForTable, translateUIConfigForAddEdit } from '../../../common/utility';

const { READ_ONLY_FEATURES } = process.env;

const CriteriaResourcesManager = ({ userContext }) => {
    const { sessionToken } = userContext;
    const [editing, setEditing] = React.useState(null);
    const [deleting, setDeleting] = React.useState(null);
    const [fatalError, setFatalError] = React.useState(null);
    const saveDisabled = READ_ONLY_FEATURES === 'true';
    const { data, isLoading } = useCriteriaResources(sessionToken);
    const { columns, actions, initialState } = translateUIConfigForTable(uiConfig, setEditing, setDeleting);
    const tableData = React.useMemo(() => {
        if (!data) return [];
        if (actions != null) {
            return actions != null
                ? data.map((v) => ({
                      ...v,
                      DataTableActions: actions.map((i) => ({
                          ...i,
                          action: () => i.action(v[uiConfig.primaryKey])
                      }))
                  }))
                : data;
        } else {
            return data;
        }
    }, [data, actions]);

    const getItemById = React.useCallback(
        (id) => {
            return tableData.find((item) => item[uiConfig.primaryKey] === id);
        },
        [tableData]
    );

    const fetchDeleteData = () => {
        return getItemById(deleting);
    };

    const closeAddEdit = () => {
        setEditing(null);
    };

    const closeDelete = () => {
        setDeleting(null);
    };
    const isExistingDoc = (doc) => {
        return (
            (data ?? []).find((v) => {
                return v.resourceId !== doc.resourceId && v.name === doc.name;
            }) !== undefined
        );
    };

    const controlButtons = [];
    if (crudConfig.functions.insert) {
        controlButtons.push(
            <Button key={'add-new'} appearance="primary" onClick={() => setEditing('new')}>
                Add New Criteria Resource
            </Button>
        );
    }

    return (
        <>
            <Table
                withHeader={true}
                columns={columns}
                data={tableData}
                withActions={actions !== null}
                id={'criteria-resource-manager'}
                label={'Criteria Resource Manager'}
                showControlDeck={true}
                paginated={true}
                loading={isLoading}
                controlButtons={controlButtons}
                initialState={initialState}
            />
            {editing != null && (
                <AddEdit
                    formModel={translateUIConfigForAddEdit(uiConfig)}
                    saveDisabled={saveDisabled}
                    selectedResourceId={editing}
                    closeDialog={closeAddEdit}
                    sessionToken={sessionToken}
                    isExistingDoc={isExistingDoc}
                    onMount={typeof uiConfig.onFormMount === 'function' ? uiConfig.onFormMount : undefined}
                />
            )}
            {deleting != null ? (
                <DeleteResource data={fetchDeleteData()} closeDialog={closeDelete} sessionToken={sessionToken} />
            ) : null}
        </>
    );
};

export default CriteriaResourcesManager;

CriteriaResourcesManager.propTypes = {
    userContext: PropTypes.object
};
